export function capitalizeFirstLetter(text) {
    // Si el texto viene nulo, vacío o indefinido, devolvemos un texto vacío para evitar errores
    if (!text) return "";
    
    // Convierte en string por si acaso, toma la primera letra (mayúscula) y le suma el resto
    const str = String(text);
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function capitalizeWords(text) {
    if (!text) return "";
    
    const str = String(text);
    return str
        .split(' ')
        .map(word => {
            // Verifica que la palabra no esté vacía (por si hay dobles espacios)
            if (!word) return "";
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        })
        .join(' ');
}

// Lista de colores pasteles bonitos
const PASTEL_COLORS = [
    '#FFB3BA',
    '#f0cca3',
    '#c2df8d',
    '#c9903b9f',
    '#E8BAFF',
    '#c2c1fd',
];
export const getAvatarColor = (name) => {
    if (!name) return '#c8cbcf';
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return PASTEL_COLORS[Math.abs(hash) % PASTEL_COLORS.length];
};

// Agrega aquí todas las rutas a tus imágenes por defecto
export const RANDOM_COURSE_IMAGES = [
    "/img/course/1.webp",
    "/img/course/2.webp",
    "/img/course/3.webp",
    "/img/course/4.webp",
    "/img/course/5.webp",
    "/img/course/6.webp",
    "/img/course/7.webp",
    "/img/course/8.webp",
    "/img/course/9.webp",
    "/img/course/10.webp",
    "/img/course/11.webp",
    "/img/course/12.webp",
    "/img/course/13.webp",
    "/img/course/14.webp",
    "/img/course/15.webp",
    "/img/course/16.webp",
    "/img/course/17.webp",
    "/img/course/18.webp",
    "/img/course/19.webp",
];